import { createContext, useContext, useMemo } from 'react';
import { authService } from '../auth/authService.js';

/**
 * SessionProvider.jsx
 *
 * Exposes the raw session (whatever the backend returned at login)
 * plus a logout() action. Core code reads `session.system.modules`,
 * `session.system.theme`, etc. generically — it never branches on
 * `session.system.id`.
 */

const SessionContext = createContext(null);

export function SessionProvider({ session, onLogout, children }) {
  const value = useMemo(
    () => ({
      session,
      user: session?.user ?? null,
      logout: () => {
        authService.logout();
        onLogout?.();
      },
    }),
    [session, onLogout]
  );

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession() {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession must be used within a SessionProvider');
  return ctx;
}
